import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="22" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 4c0-2.21-1.79-4-4-4S4 1.79 4 4s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM0 14v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.78 1.28 6 2H2zm17-3V8h3V6h-3V3h-2v3h-3v2h3v3h2z" fill="#444" /></svg>;